import { Stack, Typography } from '@mui/material';
import React from 'react';
import { CreateCustomerAddressSection } from './create-customer-company-details-components/CreateCustomerAddressSection';
import { CreateCustomerContactsSection } from './create-customer-company-details-components/CreateCustomerContactsSection';
import { CreateCustomerGeneralInformation } from './create-customer-company-details-components/CreateCustomerGeneralInformation';

export const CreateCustomerCompanyDetails: React.FC = () => {
  return (
    <Stack spacing={3}>
      <Typography variant="h5" sx={{ fontWeight: 500, paddingTop: 1 }}>
        Company Details
      </Typography>

      <CreateCustomerGeneralInformation />
      <CreateCustomerAddressSection />
      <CreateCustomerContactsSection />
    </Stack>
  );
};
